// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React, {useRef, useEffect, Fragment} from 'react';
import cn from 'classnames';

import zurl from 'zurl';
import hopt from 'hola_opt';
import etask from 'zetask';
import {i_plan} from '../../../../../hola/pub/plus/plus_types';
import {Input} from '../../../../../hola/pub/lib/input';
import experiment_init from '../../../../../hola/pub/experiment_init';
import plus_util from '/www/hola/pub/plus_util.js';
import zutil from '/util/util.js';
import styles from './gpay_stripe.module.less';
// // @ts-ignore
// import {get_price_plan} from '/svc/account/pub/membership.js';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {i_user_info} from 'hola_app_context';
import {get_payment_opts} from '../helpers/helpers';
import {Purchase_disabled_warning} from
    '../../checkout/payment_form/payment_form';

export type t_stripe_methods =
    | 'googlePay'
    | 'applePay'
    | 'paypal'
    | 'link'
    | 'klarna'
    | 'demoPay'
    | 'amazonPay';
type t_available_methods = Record<t_stripe_methods, boolean>;

type t_gpay_stripe_props = {
    plan: i_plan;
    user: i_user_info;
    hidden?: boolean;
    method_config: {
        test: string;
        live: string;
    };
    on_fallback: ()=>void;
    on_submit?: ()=>void;
    on_before_payment?: ()=>void;
    on_after_payment?:
        (opt: {payment_intent_id: string;}, email: string)=>void;
    disabled?: boolean;

    // victorf
    // use Email_field instead of this methods
    email: string;
    set_email: (email: string)=>void;
    email_err: string;
    set_email_err: (email_err: string)=>void;
}

const zero_decimal_currencies = ['BIF', 'CLP', 'DJF', 'GNF', 'JPY', 'KMF',
    'KRW', 'MGA', 'PYG', 'RWF', 'UGX', 'VND', 'VUV', 'XAF', 'XOF', 'XPF'];

const encode_amount = (price: number, currency: string)=>{
    currency = currency.toUpperCase();
    if (zero_decimal_currencies.includes(currency))
        return price;
    return +(price*100).toFixed();
};


const email_validator = email=>etask(function*(){
    if (hopt.www_hola.no_email_validation_on_blur)
        return '';
    const err = email && plus_util.validate_email_syntax(email);
    return err ? err : yield plus_util.validate_email_domain(email);
});

// https://docs.stripe.com/billing/subscriptions/build-subscriptions
export const Gpay_stripe = (props: t_gpay_stripe_props)=>{
    const {plan, hidden, method_config, on_before_payment, on_after_payment,
        on_fallback: on_no_methods, disabled: purchase_disabled} = props;
    const currency = 'usd';
    const bundle = 'toolip';

    const amount = encode_amount(Number(plan.price), currency);
    const sbx = !!plus_util.api.test_env;
    const get_info = ()=>{
        const {email, user, is_new_user} =
            get_payment_opts(props.user, props.email);
        return {
            email,
            user,
            is_new_user,
            hola_uid: user?.hola_uid,
            plan_id: sbx ? plan.stripe_test_id : plan.stripe_id,
            sbx,
            hola_plan_id: plan.id,
            bundle,
            quantity: 1,
            stripe_method: 'gpay',
            use_discount:
                !!experiment_init?.ui_test?.test_discount_prices,
            ...plus_util.get_custom_opt(),
        };
    };
    const ref_prop = useRef({props: props});
    useEffect(()=>{
        ref_prop.current.props = props;
    }, [props]);
    // saving get_info to ref to have new props inside
    // button_el's callbacks without reattaching them
    const get_info_ref = useRef<typeof get_info>();
    get_info_ref.current = get_info;
    const _perr = (id: string, add_info: Record<string, unknown> = {})=>{
        const info = {...get_info_ref.current(), ...add_info};
        plus_util.perr({id: `www_premium_payment_stripe_gpay_${id}`, info});
        id.includes('_err') ? console.error({id, info: add_info})
                             : console.log({id, info: add_info});
    };

    const container_ref = useRef(null);
    const stripe_ref = useRef(null);
    const button_ref = useRef(null);
    const elements_ref = useRef(null);
    const on_click = (event: {resolve: ()=>void;})=>{
        const {email} = get_info_ref.current();
        if (!email)
        {
            ref_prop.current.props.set_email_err(plus_util.empty_email_err);
            return;
        }
        if (!zurl.is_valid_email(email))
        {
            ref_prop.current.props.set_email_err('Email invalid');
            return;
        }

        event.resolve();
        _perr('submit_clicked');
        if (ref_prop.current.props.on_submit)
            ref_prop.current.props.on_submit();
    };
    const on_ready = (event: {
        elementType: 'expressCheckout';
        availablePaymentMethods?: t_available_methods;
    })=>{
        if (!Object.keys(event.availablePaymentMethods ?? {}).length)
            on_no_methods();
    };
    const on_confirm = (event: {
        elementType: 'expressCheckout';
        expressPaymentType: t_stripe_methods;
        billingDetails?: {name: string;};
    })=>etask(function*(){
        const info = get_info_ref.current();
        if (on_before_payment)
            yield on_before_payment();
        _perr('confirm_clicked');

        const subscr_res = yield fetch(
            '/users/payment/stripe_payment', {
            method: 'POST', contentType: 'application/json',
            body: JSON.stringify({name: event.billingDetails?.name,
                ...info}),
        });
        const client_secret = subscr_res?.subscr?.
            latest_invoice?.payment_intent?.client_secret;
        if (!client_secret)
        {
            _perr('create_subscr_err', {err: subscr_res});
            throw new Error(`stripe_create_subscr_gpay is not ok: ${
                subscr_res}`);
        }
        const payment_intent_id = subscr_res.subscr.metadata.payment_intent_id;
        const return_url = 'https://toolip.io/dashboard/page/plans?thank_you=1'
            + `&email=${encodeURIComponent(info.email)}`;

        const stripe_res = yield stripe_ref.current.confirmPayment({
            clientSecret: client_secret,
            elements: elements_ref.current,
            redirect: 'if_required',
            confirmParams: {return_url},
        });
        if (stripe_res.error)
        {
            _perr('api_confirm_payment_err', {err: stripe_res.error});
            throw new Error(`api.stripe.confirmPayment is not ok: ${
                stripe_res}`);
        }
        const confirm_res = yield fetch(
            '/users/payment/confirm_stripe_payment_subsc', {
                method: 'POST',
                contentType: 'application/json',
                body: JSON.stringify({payment_intent_id, sbx}),
            });
        if (confirm_res.result !== 'done, created membership')
        {
            _perr('confirm_subsc_err', {err: confirm_res});
            throw new Error(`confirm_stripe_payment_subsc is not ok: ${
                confirm_res}`);
        }
        if (on_after_payment)
            yield on_after_payment({payment_intent_id}, info.email);
        _perr('www_premium_payment_subscription_success_stripe_gpay');
    });

    useEffect(()=>{
        const id = setInterval(()=>{
            if (!(window as any).Stripe)
                return;
            const api_type = sbx ? 'test' : 'live';
            const stripe_opt = zutil.get(hopt,
                `stripe.${api_type}`);
            const stripe = (window as any).Stripe(stripe_opt);
            stripe_ref.current = stripe;
            // https://docs.stripe.com/js/elements_object/
            // create_without_intent#stripe_elements_no_intent-options-mode
            const elements = stripe.elements({
                mode: 'subscription',
                amount,
                currency,
                setupFutureUsage: 'off_session',
                paymentMethodConfiguration: method_config[api_type],
            });
            elements_ref.current = elements;
            const button_el = elements.create('expressCheckout');
            button_ref.current = button_el;
            button_el.on('ready', on_ready);
            button_el.on('click', on_click);
            button_el.on('confirm', on_confirm);
            button_el.mount(container_ref.current);
            clearInterval(id);
        }, 100);
        return ()=>clearInterval(id);
    }, []);

    return <Fragment>
        {!hidden && purchase_disabled ? <Purchase_disabled_warning/> :
        <div className={cn(styles.gpay_container,
          hidden && styles.gpay_container_hidden)}>
          <div ref={container_ref}/>
        {!props.user && <Input
          cl={styles.email_field}
          on_change_validation={false}
          name="email" auto_complete="email" value={props.email}
          validator={email_validator} inputmode="email"
          placeholder="name@example.com" label="Email"
          on_validation={props.set_email_err} error={props.email_err}
          on_change={props.set_email}/>}
        </div>}
      </Fragment>;
};
